$(document).ready(function () {
    var loader =
        '<div class="sk-fading-circle _deprecated">\
		 <div class="sk-circle1 sk-circle _deprecated"></div>\
		 <div class="sk-circle2 sk-circle _deprecated"></div>\
		 <div class="sk-circle3 sk-circle _deprecated"></div>\
		 <div class="sk-circle4 sk-circle _deprecated"></div>\
		 <div class="sk-circle5 sk-circle _deprecated"></div>\
		 <div class="sk-circle6 sk-circle _deprecated"></div>\
		 <div class="sk-circle7 sk-circle _deprecated"></div>\
		 <div class="sk-circle8 sk-circle _deprecated"></div>\
		 <div class="sk-circle9 sk-circle _deprecated"></div>\
		 <div class="sk-circle10 sk-circle _deprecated"></div>\
		 <div class="sk-circle11 sk-circle _deprecated"></div>\
		 <div class="sk-circle12 sk-circle _deprecated"></div>\
	</div>';

    var loader_wrapper = '<div class="loader _deprecated">' + loader + '</div>';

    $('.list').tabs({
        disabled: [4, 4],
    });
    // $.featureList($('#tabs li a'), $('#output li'), {
    //     start_item: 0,
    // });
    // $('#slider1').tinycarousel({
    //     display: 3
    // });

    $('input[name="login"]').click(function (event) {
        $(this).css('display', 'none');
        $(loader_wrapper).insertAfter($(this));
    });

    $('input[name="register"]').click(function (event) {
        $(this).css('display', 'none');
        $(loader_wrapper).insertAfter($(this));
    });

    // AJAX FUNCTIONALITY LOGIN
    $('#login-form').ajaxForm({
        success: function (result) {
            if (result.status === 'success') {
                if (result.message) {
                    $('#login-form').html('<p id="no_errors" class="_deprecated">' + result.message + '</p>');
                } else {
                    if (result.redirect) {
                        window.location.href = result.redirect;
                    } else {
                        window.location.reload();
                    }
                }
            } else {
                $('input[name="login"]').css('display', 'block');
                $('#login-form .loader').remove();
                $('#login_errors').html('');
                $('#login_errors').show();
                $('#login-form label').css('color', '#31353E');
                $.each(result.errors, function () {
                    var value = this;
                    $("<li class='_deprecated'>" + value.message + '</li>').appendTo($('#login_errors'));

                    var fields = [];
                    if (value.field) fields.push(value.field);
                    if (value.fields) fields = fields.concat(value.fields);

                    $.each(fields, function () {
                        var field = this;
                        $('#login-form [name="' + field + '"]')
                            .prev()
                            .css('color', 'red');
                    });
                });
                // $( ".login-error" ).html( result.message );
            }
        },
        error: function (err) {
            // Melding, er ging iets fout bij het versturen, probeer opnieuw
        },
    });

    // AJAX FUNCTIONALITY REGISTER
    $('#register-form').submit(function (e) {
        e.preventDefault();
        var form = this,
            ajaxOptions = {
                success: function (result) {
                    if (result.status === 'success') {
                        $('#no_errors').show();
                        $('input[name="register"]').css('display', 'block');
                        $('#register-form .loader').remove();
                        $('#register-form').html(
                            '<p id="no_errors" class="_deprecated">' + result.message + '</p>'
                        );
                        if (result.redirect) {
                            // Redirect after showing the message
                            setTimeout(function () {
                                window.location.href = result.redirect;
                            }, 5000);
                        }
                    } else {
                        $('input[name="register"]').css('display', 'block');
                        $('#register-form .loader').remove();
                        $('#register_errors').html('');
                        $('#register_errors').show();
                        $('#register-form label').css('color', '');

                        $.each(result.errors, function () {
                            var value = this;
                            $("<li class='_deprecated'>" + value.message + '</li>').appendTo(
                                $('#register_errors')
                            );

                            var fields = [];
                            if (value.field) fields.push(value.field);
                            if (value.fields) fields = fields.concat(value.fields);

                            $.each(fields, function () {
                                var field = this;
                                $('#register-form label[for="' + field + '"]').css('color', 'red');
                            });
                        });
                    }
                },
            };
        grecaptcha
            .execute(window.RECAPTCHA_SITEKEY, {
                action: 'register',
            })
            .then(function (token) {
                var element = $(form).find('[name=g-recaptcha-response]');
                element.val(token);
                $(form).ajaxSubmit(ajaxOptions);
            });
    });

    // AJAX FUNTIONALITY PASSWORD FORGOTTEN
    $('#password_forgotten_form').ajaxForm({
        success: function (result) {
            if (result.status === 'success') {
                $('#password_forgotten_form').html(
                    '<p id="no_errors" class="_deprecated">' + result.message + '</p>'
                );
                $('#no_errors').show();
            } else {
                console.log(result);
                $('#password_forgotten_errors').html('');
                $('#password_forgotten_errors').show();
                $('#password_forgotten_form label').css('color', '#31353E');
                $.each(result.errors, function () {
                    var value = this;
                    $("<li class='_deprecated'>" + value.message + '</li>').appendTo(
                        $('#password_forgotten_errors')
                    );

                    var fields = [];
                    if (value.field) fields.push(value.field);

                    $.each(fields, function () {
                        var field = this;
                        $('#password_forgotten_form [name="' + field + '"]')
                            .prev()
                            .css('color', 'red');
                    });
                });
            }
        },
    });

    // ADD OR REMOVE CLUB/PLAYER TO/FROM USER
    $(document).on('click', '.follow, .fan', function (object) {
        var element = $(this);

        var userID = $(this).attr('userid');
        var tagID = $(this).attr('tagid');
        var action = $(this).attr('action');

        var url = '/requests/fan.php?domain_id=' + domain_id;

        $.ajax({
            type: 'GET',
            url: url,
            data: 'user=' + userID + '&tag=' + tagID + '&action=' + action,
            success: function (result) {
                if (result === 'ADDED') {
                    element.addClass('followed');
                    element.removeClass('add');
                    element.attr('action', 'remove');

                    if (element.hasClass('fan')) {
                        element.html(translations['fan.ready']);
                        if (!element.parent('li')) {
                            element.parents()[1].children[5].innerHTML =
                                parseInt(element.parents()[1].children[5].innerHTML) + 1;
                        }
                    } else if (element.hasClass('follow')) {
                        element.html(translations['followed.apply']);
                        element.parent()[0].children[1].innerHTML =
                            parseInt(element.parent()[0].children[1].innerHTML) + 1;
                    }
                } else if (result === 'REMOVED') {
                    if (element.hasClass('profile_p')) {
                        element.parent().fadeOut('Fast', function () {
                            $(this).remove();
                        });
                    } else {
                        element.removeClass('followed');
                        element.addClass('add');
                        element.attr('action', 'add');

                        if (element.hasClass('fan')) {
                            element.html(translations['fan.apply']);
                            element.parents()[1].children[5].innerHTML =
                                parseInt(element.parents()[1].children[5].innerHTML) - 1;
                        } else if (element.hasClass('follow')) {
                            element.html(translations['follow.apply']);
                            element.parent()[0].children[1].innerHTML =
                                parseInt(element.parent()[0].children[1].innerHTML) - 1;
                        }
                    }
                }
            },
        });
    });

    // AJAX FUNCTIONALITY LOAD MORE
    $(document).on('click', '.loadmore', function (object) {
        var nid = $(this).attr('id');
        var class_id = $(this).attr('class');
        var type = $(this).attr('type') || '';
        var search_title = $(this).attr('q') || '';
        var page = $(this).attr('page') || '';
        var t = $(this).attr('t') || '';
        var c = $(this).attr('c') || '';
        var moreValue = $(this).attr('more');
        var homeValue = $(this).attr('home');

        var url = '/requests/index.php?domain_id=' + window.domain_id;

        var onSuccess = function (html) {
            $('.sk-fading-circle').closest('li').remove();

            var $items = $(html).find('ul.articles li');

            if ($items.length === 0) {
                $('section.article-list' + type)
                    .first()
                    .append(html); //Append the html returned by the server
            } else {
                $('section.article-list ul.articles').not('.dossier-module *').first().append($items); //Append the html returned by the server
            }
            refreshDeprecatedStyles();
        };

        var beforeSend = function () {
            $('.loadmore').parent().html(loader);
        };

        if (page == 'search') {
            var textSearch = $('.textSearch').is(':checked') ? 1 : 0;

            $.ajax({
                type: 'GET',
                url: url,
                data: {
                    limit: nid,
                    tab: 1,
                    q: search_title,
                },
                beforeSend: beforeSend,
                success: onSuccess,
            });
        } else if (nid != '') {
            $.ajax({
                type: 'POST',
                url: url,
                data: {
                    limit: nid,
                    tab: type,
                    t: t,
                    c: c,
                    search: search_title,
                    more: moreValue,
                    home: homeValue,
                },
                beforeSend: beforeSend,
                success: onSuccess,
            });
        }

        return false;
    });
});
